const ItemHeader = ({previewItem, isVisible, showReadMore, showDescription, setShowReadMore, service}) => {
  return (
    <>
      <div className="preview__item-header">
        <span className="preview__item-title">{previewItem.title}</span>
        {showDescription ? (
          <button
            className="preview__item-action"
            onClick={() => setShowReadMore(!showReadMore)}
          >
            {showReadMore ? "Close" : "Read more"}
            <i className={showReadMore ? "icon__up" : "icon__down"} />
          </button>
          ) : (<></>)}
      </div>
      {service === 'cropper' || service === 'resizer' ? (
        <div
          className={`preview__item-description ${
            showReadMore ? "preview__item-description_visible" : ""
          }`}
          dangerouslySetInnerHTML={{
            __html: `${service === 'cropper' ? previewItem.descriptionCrop : previewItem.description}`,
          }}
        >
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
export default ItemHeader;
